class User {
  static showSearchModal(show) {
    return {
      payload: show,
      type: 'SHOW_SEARCH_MODAL',
    }
  }
}

export default User
